
export const useFormNavigation = (pricestepData, setNextStep) => {

  const validateField = (fieldName, value) => {
    // Add your validation logic for each field
    switch (fieldName) {
      case 'weight':
        return value && parseFloat(value) >= 1 && parseFloat(value) <= 30;
      case 'shape':
        return !!value;
      case 'color':
        return !!value;
      case 'saturation':
        return !!value;
      case 'clarity':
        return !!value;
      case 'fluorescence':
        return !!value;
      case 'ratio':
        return !!value;
      case 'polish':
        return !!value;
      case 'symmetry':
        return !!value;
      default:
        return true;
    }
  };
  const fieldOrder = [
    'weight',
    'shape',
    'color',
    'saturation',
    'clarity',
    'fluorescence',
    'ratio',
    'polish',
    'symmetry'
  ];
  const focusNextField = (currentFieldName) => {
    const currentIndex = fieldOrder.indexOf(currentFieldName);
    if (currentIndex === -1) return;
    const nextField = fieldOrder[currentIndex + 1];
    const nextFieldElement = document.querySelector(`[data-field="${nextField}"]`);
    if (nextFieldElement) {
      nextFieldElement.focus();
    }

  };

  const focusNextValidField = (currentFieldName) => {
    const currentIndex = fieldOrder.indexOf(currentFieldName);
    if (currentIndex === -1) return;

    //  for skipping the filled fields
    for (let i = currentIndex + 1; i < fieldOrder.length; i++) {
      const nextField = fieldOrder[i];
      const value = pricestepData[nextField];
      console.log("value", value);
      console.log("nextField", nextField);

      if (!value) {
        setTimeout(() => {
          const element = document.querySelector(`[data-field="${nextField}"]`);
          if (element) {
            element.focus();
          }
        }, 10);
        break;
      }
    }
  };

  return {
    validateField,
    focusNextField,
    focusNextValidField
  };
}; 